/*! tailwindcss v4.2.2 | MIT License | https://tailwindcss.com */
@layer properties;
@layer components {
  .input {
    display: flex;
    width: 100%;
    cursor: text;
    appearance: none;
    align-items: center;
    border-radius: var(--radius-sm, 0.25rem);
    border-style: var(--tw-border-style);
    border-width: 1px;
    background-color: var(--base-white);
    color: var(--base-grey-800);
    --tw-outline-style: none;
    outline-style: none;
    @media (forced-colors: active) {
      outline: 2px solid transparent;
      outline-offset: 2px;
    }
    @media (prefers-reduced-motion: no-preference) {
      transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
      transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
      transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
    }
    &::placeholder {
      color: var(--base-grey-600);
    }
    &:read-only {
      border-color: var(--base-grey-400) !important;
    }
    &:read-only {
      background-color: var(--base-grey-100);
    }
    &:read-only {
      color: var(--base-grey-500);
    }
    &:read-only {
      &::placeholder {
        color: var(--base-grey-400);
      }
    }
    &[aria-disabled="true"] {
      cursor: not-allowed;
    }
    &[aria-busy="true"] {
      cursor: wait;
    }
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &[type="number"]::-webkit-inner-spin-button {
      margin-block: calc(var(--spacing, 0.25rem) * -2);
      margin-inline-end: calc(var(--spacing, 0.25rem) * -3);
    }
    & input {
      display: flex;
      width: 100%;
      height: 100%;
      appearance: none;
      --tw-border-style: none;
      border-style: none;
      background-color: transparent;
      --tw-outline-style: none;
      outline-style: none;
      @media (forced-colors: active) {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    }
  }
  .neutral {
    border-color: var(--base-grey-400);
    --tw-ring-color: var(--color-primary-500);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--color-primary-500) 30%, transparent);
    }
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-primary-500);
      }
    }
    &:focus-visible {
      border-color: var(--color-primary-500);
    }
  }
  .error {
    border-color: var(--base-red-500);
    --tw-ring-color: var(--base-red-500);
    @supports (color: color-mix(in lab, red, red)) {
      --tw-ring-color: color-mix(in oklab, var(--base-red-500) 30%, transparent);
    }
  }
  .sm {
    height: calc(var(--spacing, 0.25rem) * 6.5);
    padding-inline: calc(var(--spacing, 0.25rem) * 2);
    font-size: var(--text-xs, 0.75rem);
    line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  }
  .md {
    height: calc(var(--spacing, 0.25rem) * 8);
    padding-inline: calc(var(--spacing, 0.25rem) * 3);
    font-size: var(--text-13, 0.8125rem);
  }
  .lg {
    height: calc(var(--spacing, 0.25rem) * 10);
    padding-inline: calc(var(--spacing, 0.25rem) * 4);
    font-size: var(--text-sm, 0.875rem);
    line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  }
  .eyeButton {
    :where(.input.sm) & {
      margin-inline: calc(var(--spacing, 0.25rem) * -1);
    }
    :where(.input.md) & {
      margin-inline: calc(var(--spacing, 0.25rem) * -1.5);
    }
    :where(.input.lg) & {
      margin-inline: calc(var(--spacing, 0.25rem) * -2);
    }
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
    }
  }
}
